module.exports = __webpack_public_path__ + "img/img9.677b1805.svg";